import { generateTestId } from "@client-shared";

export const setOrderDetailDialogTestId = (identifier: string): string => generateTestId("OrderDetailDialog", identifier);

export const ORDER_DETAIL_SECTIONS = {
  content: "content",
  statusBadge: "statusBadge",
  headerRow: "headerRow",
  shippingAddress: "shippingAddress",
  lineItem: "lineItem",
  metadata: "metadata",
  batchLink: "batchLink",
  actions: "actions",
  vendorLink: "vendorLink",
} as const;
